import { Chat as GenericChat } from '@components'
import type { Component } from 'solid-js'
import { useService } from 'solid-services'
import { useSingleChat } from '../state/singleChat'

const Chat: Component = () => {
	const { currentChannelId } = useService(useSingleChat)()

	return (
		<GenericChat
			height="calc(100vh - 142px)"
			currentChannelId={currentChannelId()}
		/>
	)
}

export default Chat
